module.exports = __webpack_public_path__ + "img/placeholdercnp.6d76f5ab.jpg";